/**
 * Content Lock Component
 * Prevents background scrolling and injects homepage button into Shopify Forms success message
 */

class ContentLock {
  constructor(element) {
    this.element = element;
    this.buttonInjected = false;
    this.init();
  }

  init() {
    this.preventBackgroundScroll();
    this.injectHomepageButton();
  }

  preventBackgroundScroll() {
    document.body.style.overflow = "hidden";
  }

  injectHomepageButton() {
    const redirectUrl = window.themeSettings?.redirect_url || "";
    // TODO: Update this Conditional logic when Mohnish's Authentication PR is up
    const shouldShowButton = redirectUrl === "";

    if (!shouldShowButton) return;

    const tryInjectButton = () => {
      if (this.buttonInjected) return true;

      const formEmbed = this.element.querySelector("shopify-forms-embed");
      if (!formEmbed || !formEmbed.shadowRoot) return false;

      const shadowRoot = formEmbed.shadowRoot;
      const successState = shadowRoot.querySelector(
        '[data-current-step="success"]'
      );
      if (!successState) return false;

      const successBanner = shadowRoot.querySelector(
        '[data-testid="banner-success"]'
      );
      if (!successBanner) return false;

      if (shadowRoot.querySelector(".custom-homepage-button")) {
        this.buttonInjected = true;
        return true;
      }

      const button = document.createElement("a");
      button.href = "/";
      button.className = "custom-homepage-button";
      button.textContent = "Back to the homepage";
      button.style.cssText = `
        display: block;
        width: 100%;
        max-width: 400px;
        margin: 2rem auto 0;
        padding: 1.5rem 2rem;
        background-color: rgba(var(--color-button));
        color: rgba(var(--color-button-text));
        text-align: center;
        text-decoration: none;
        border-radius: 6px;
        font-size: 1.4rem;
        font-weight: 500;
        transition: all 0.2s ease;
        cursor: pointer;
      `;

      const style = document.createElement("style");
      style.textContent = `
        .custom-homepage-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        .custom-homepage-button:active {
          transform: translateY(0);
        }
      `;

      shadowRoot.appendChild(style);
      successBanner.appendChild(button);

      this.buttonInjected = true;
      return true;
    };

    const observer = new MutationObserver(() => tryInjectButton());

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    tryInjectButton();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-content-lock]").forEach((element) => {
    new ContentLock(element);
  });
});